export const version = "1.0.2-daily-20260527-0";
export const channel = "daily";
export const gitcommit = "4736c138b";
